module.exports = __webpack_public_path__ + "static/React Router-f4706ad25b9e9ca9720932652ec342ca.png";